<ng-container *ngIf="(profile$ | async) as profile">
  <prlw-demo-access-ui
    (closeModal)="exit()"
    [profile]="profile"
  ></prlw-demo-access-ui>
</ng-container>
